export default {
  sm: `
  Data center that plans<br> 
  your tomorrow 
  `,
};
